import NewWedingModal from './NewWedingModal'
import styles from './NewWedingModal.module.scss'
import ButtonCustom from '../../../components/atoms/button/ButtonCustom'
import Stepper from '../../../components/atoms/Stepper/Stepper'
import { toastHelper } from '../../../util/toastHelper'

const music = ['DJ', 'Live Music', 'Both', 'Not Sure']

function LiveMusic({
	open,
	handleClose,
	handleNext,
	handleBack,
	weddingData,
	setWeddingData,
}) {
	return (
		<NewWedingModal
			open={open}
			handleClose={handleClose}
			handleBack={() => handleBack()}
			modalImage="/images/GuestCount.jpg"
		>
			<div
				className={`${styles.welcomeModal} ${styles.guestCount} ${styles.modalMainContainer}`}
			>
				<div className={styles.welcomeModalBody}>
					<h2>
						Do you want to have a DJ (Disc Jockey) or Live Music?
					</h2>
					<div
						className=""
						style={{ width: '100%', marginTop: '40px' }}
					>
						<div className={styles.modalContainer}>
							<div className={styles.Budget}>
								{music.map((label, idx) => (
									<ButtonCustom
                                        key={idx}
										variant="pilled"
										style={{
											backgroundColor:
												weddingData?.music === label
													? '#7ca6bd'
													: '#FFF',
											color:
												weddingData?.music === label
													? '#FFF'
													: '#7ca6bd',
										}}
										onClick={() =>
											setWeddingData({
												...weddingData,
												music: label,
											})
										}
									>
										{label}
									</ButtonCustom>
								))}
							</div>
						</div>
					</div>
				</div>
				<ButtonCustom
					size="lg"
					data-cy="wizard-next"
					onClick={() => {
						if (!weddingData.music)
							return toastHelper(
								'Please select an option',
								'error'
							)
						handleNext()
					}}
				>
					Next
				</ButtonCustom>
				<div className={styles.buttonContainer}>
					<Stepper activeStep={2.99} />
				</div>
			</div>
		</NewWedingModal>
	)
}

export default LiveMusic
